/* This file is based on `vscode-lean4/src/taskgutter.ts` */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { LeanFileProgressKind } from '@leanprover/infoview-api';
var LeanFileTaskGutter = /** @class */ (function () {
    function LeanFileTaskGutter(editor, decorations, processed) {
        this.editor = editor;
        this.decorations = decorations;
        this.processed = processed;
        this.decoIds = [];
        this.schedule(100);
    }
    LeanFileTaskGutter.prototype.setProcessed = function (processed) {
        if (processed === this.processed)
            return;
        var oldProcessed = this.processed;
        this.processed = processed;
        if (processed === undefined) {
            this.processed = [];
            this.clearTimeout();
            this.updateDecos();
        }
        else if (this.timeout === undefined) {
            this.schedule(oldProcessed === undefined ? 500 : 20);
        }
    };
    LeanFileTaskGutter.prototype.schedule = function (ms) {
        var _this = this;
        this.timeout = setTimeout(function () {
            _this.timeout = undefined;
            _this.updateDecos();
        }, ms);
    };
    LeanFileTaskGutter.prototype.clearTimeout = function () {
        if (this.timeout !== undefined) {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        }
    };
    LeanFileTaskGutter.prototype.updateDecos = function () {
        var _this = this;
        this.decoIds = this.editor.getModel().deltaDecorations(this.decoIds, this.processed
            .map(function (info) { return ({
            options: _this.decorations.get(info.kind === undefined ? LeanFileProgressKind.Processing : info.kind),
            range: new monaco.Range(info.range.start.line, 0, info.range.end.line, 0)
        }); }));
    };
    LeanFileTaskGutter.prototype.dispose = function () {
        this.clearTimeout();
    };
    return LeanFileTaskGutter;
}());
var LeanTaskGutter = /** @class */ (function () {
    function LeanTaskGutter(client, editor) {
        var _this = this;
        this.client = client;
        this.editor = editor;
        this.decorations = new Map();
        this.status = {};
        this.gutters = {};
        this.subscriptions = [];
        this.decorations.set(LeanFileProgressKind.Processing, {
            overviewRuler: {
                position: monaco.editor.OverviewRulerLane.Left,
                color: 'rgba(255, 165, 0, 0.5)',
            },
            glyphMarginClassName: 'processing',
            hoverMessage: { value: 'busily processing...' }
        });
        this.decorations.set(LeanFileProgressKind.FatalError, {
            overviewRuler: {
                position: monaco.editor.OverviewRulerLane.Left,
                color: 'rgba(255, 0, 0, 0.5)',
            },
            glyphMarginClassName: 'glyph-margin-error',
            hoverMessage: { value: 'processing stopped' }
        });
        this.subscriptions.push(client.progressChanged(function (_a) {
            var _b = __read(_a, 2), uri = _b[0], processing = _b[1];
            _this.status[uri.toString()] = processing;
            _this.updateDecos();
        }));
    }
    LeanTaskGutter.prototype.updateDecos = function () {
        var e_1, _a;
        var _b;
        var uris = {};
        // for (const editor of window.visibleTextEditors) {
        var uri = this.editor.getModel().uri.toString();
        uris[uri] = true;
        var processed = uri in this.status ? this.status[uri] : [];
        if (this.gutters[uri]) {
            var gutter = this.gutters[uri];
            if (gutter)
                gutter.setProcessed(processed);
        }
        else {
            this.gutters[uri] = new LeanFileTaskGutter(this.editor, this.decorations, processed);
        }
        try {
            // }
            for (var _c = __values(Object.getOwnPropertyNames(this.gutters)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var uri_1 = _d.value;
                if (!uris[uri_1]) {
                    (_b = this.gutters[uri_1]) === null || _b === void 0 ? void 0 : _b.dispose();
                    this.gutters[uri_1] = undefined;
                    // TODO: also clear this.status for this uri ?
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    LeanTaskGutter.prototype.dispose = function () {
        var e_2, _a;
        try {
            // for (const decoration of this.decorations.values()) { decoration.dispose() }
            for (var _b = __values(this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                s.dispose();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    return LeanTaskGutter;
}());
export { LeanTaskGutter };
